<div *ngIf="hasAcces">

  <div class="widget-navigation">
    <a href="#information" class="scrollTo transition">Information
    </a>
  </div>

  <form id="information" #validate="ngForm">
    <div class="widget-title margin-top-42"></div>
    <div class="widget width-49-perc margin-right-2-perc">
      <div class="widget-title">Network Server Group Info</div>
      <div class="info-content hide">
        <div class="widget-inner-title hide">VirtID:</div>
        <div class="widget-inner-content hide virtId">
          <input id="virtId" [value]="listInfo['virtId']" [disabled]="true" />
        </div>
      </div>

      <!--NetID field -->
      <div class="info-content">
        <div class="widget-inner-title">NetID:
          <i class="fa fa-info-circle info-text"></i>
        </div>
        <div class="widget-inner-content">
          <input *ngIf="!isAdmin" value="{{listInfo['netIds']}}" [disabled]="true" />
          <app-input-dynamic-list *ngIf="isAdmin" validationType="netId"
            protocolVersion="{{listInfo['protocolVersion']}}" virtId="{{listInfo['virtId']}}"
            [inputValueSetter]="listInfo['netIds']">
          </app-input-dynamic-list>
        </div>
      </div>

      <div class="info-content">
        <div class="widget-inner-title">Name:
          <i class="fa fa-info-circle info-text"></i>
        </div>
        <div class="widget-inner-content">

          <input *ngIf="!isAdmin" value="{{listInfo['name']}}" [disabled]="true" />

          <app-input-edit *ngIf="isAdmin" validationType="name" formType="NS" saveType="name"
            virtId="{{listInfo['virtId']}}" inputValue="{{listInfo['name']}}">
          </app-input-edit>
        </div>
      </div>

      <!--Protocol Version area-->
      <div class="info-content">
        <div class="widget-inner-title">Protocol Version:
          <i class="fa fa-info-circle info-text"></i>
        </div>
        <div class="widget-inner-content">
          <input *ngIf="!isAdmin" value="{{listInfo['protocolVersion']}}" [disabled]="true" />

          <app-protocol-edit *ngIf="isAdmin" virtId="{{listInfo['virtId']}}"
            saveType="NN" inputValue="{{listInfo['protocolVersion']}}">
          </app-protocol-edit>
        </div>
      </div>

      <div *ngIf="isAdmin" class="info-content last-row">
        <div class="widget-inner-title">Owner/Affiliation:
          <i class="fa fa-info-circle info-text"></i>
        </div>

        <div *ngIf="isAdmin" class="widget-inner-content">

          <ng-template #popoverContent>
            <p class="popup-text"
               (click)="userDetail.show();getUserDetails(item.username)"
               *ngIf="item.username">User details</p>
            <app-modal #userDetail
                       ownerUname="{{ownerUname}}"
                       ownerFname="{{ownerFname}}"
                       ownerLname="{{ownerLname}}"
                       ownerEmail="{{ownerEmail}}"
                       ownerAffiliation="{{ownerAffiliation}}"></app-modal>
          </ng-template>
          <app-edit-popover-button [popover]="popoverContent"
                                   placement="left"
                                   triggers="click"
                                   [outsideClick]="true"
                                   container="body"
                                   inputValue="{{strOwnership}}" ownerUname="{{listInfo['username']}}"
                                   ownerFname="{{ownerFname}}" ownerLname="{{ownerLname}}" ownerEmail="{{ownerEmail}}"
                                   ownerAffiliation="{{ownerAffiliation}}" virtId="{{listInfo['virtId']}}">
          </app-edit-popover-button>

        </div>
      </div>

      <div class="btn-area" [ngClass]="{'margin-top': !isAdmin}">
        <button class="btn btn-outline-success my-2 my-sm-0 transition" [ngClass]="{'isDisabled' : !isAdmin}"
          [disabled]="!isAdmin" (click)="deleteModal.show()">Delete
        </button>

        <app-delete-modal #deleteModal text="Network server group {{listInfo['name']}} will be deleted."
          server="{{listInfo['virtId']}}" deleteType="networkServerGroupDetail">
        </app-delete-modal>

      </div>
    </div>
  </form>

  <!-- GROUP NETWORK SERVERS -->
  <app-group-network-servers virtId="{{listInfo['virtId']}}"
    (groupNetworkServersLoadedEvent)="groupNetworkServersLoaded($event)"></app-group-network-servers>


  <!-- ROAMING PARTNERS-->
  <app-roaming-partners virtId="{{listInfo['virtId']}}" [netIds]="listInfo['netIds']" name="{{listInfo['name']}}"
    [renderNsGroup]="renderNsGroup" (roamingPartnersLoadedEvent)="roamingPartnersLoaded($event)"></app-roaming-partners>

  <!-- Activation Agreements -->
  <app-serving-join-servers virtId="{{listInfo['virtId']}}" [netIds]="listInfo['netIds']" name="{{listInfo['name']}}"
    protocolVersion="{{listInfo['protocolVersion']}}" [renderNsGroup]="renderNsGroup"
    (servingJoinServersLoadedEvent)="servingJoinServersLoaded($event)"></app-serving-join-servers>


  <!-- Message Logs -->
  <app-message-logs virtId="{{listInfo['virtId']}}" [netIds]="listInfo['netIds']"
    [getLogsUrl]="logsUrl" useNetIdsForSearch="true"></app-message-logs>

</div>

<div *ngIf="!hasAcces">
  <h1>{{errorStatus}}:{{errorText}}</h1>
</div>
